<template>
  <content-wrapper>
    <Content class="mt-3">
      <b-card header-bg-variant="dark">
        <template #header>
          <b-row class="align-items-center justify-content-between">
            <b-col>
              <h6 class="mb-0">Permits</h6>
            </b-col>
            <b-col md="1">
              <b-button variant="outline-light" @click.prevent="openPermitForm()">
                <b-icon icon="plus-circle-fill"></b-icon>
                Add
              </b-button>
            </b-col>
          </b-row>
        </template>
        <!-- Table Search -->
        <div class="form-group row" v-if="can('superadmin|control_room')">
          <label class="col-sm-2 col-form-label">Select Member</label>
          <div class="col-sm-10 input-group mb-3">
            <MemberDropDown v-model="selectedMember"
                            :member="member"
                            show-all-members
                            @change="pagination.current = 1;$refs.table.refresh()"
                            v-bind:members.sync="allMembers"
            ></MemberDropDown>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Search</label>
          <div class="col-sm-4 mb-3">
            <b-form-select
                v-model="searchForm.type"
                :options="options.search"
            ></b-form-select>
          </div>
          <div class="col-sm-6 mb-3">
            <b-form-input
                placeholder="Keywords"
                v-model="searchForm.keywords"
                @keydown.enter="search"
            ></b-form-input>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Filter</label>

          <div class="col-md-7 col-sm-10 mb-3">
            <b-row>
              <b-col sm="12" md="4">
                <b-form-select
                    v-model="searchForm.dateType"
                    :options="options.filterDate"
                ></b-form-select>
              </b-col>
              <b-col>
                <b-form-datepicker
                    id="startDate"
                    v-model="searchForm.startDate"
                    :max="searchForm.endDate"
                    locale="en-US"
                    label-no-date-selected="Start Date"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                ></b-form-datepicker>
              </b-col>
              <b-col>
                <b-form-datepicker
                    id="endDate"
                    v-model="searchForm.endDate"
                    locale="en-US"
                    :min="searchForm.startDate"
                    label-no-date-selected="End Date"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                ></b-form-datepicker>
              </b-col>
            </b-row>
          </div>
          <b-col class="d-flex justify-content-between flex-wrap">
                <b-form-radio-group
                    buttons
                    button-variant="outline-primary"
                    :options="options.directions"
                    name="radios-btn-direction"
                    v-model="searchForm.direction"
                    @change="pagination.current=1;$refs.table.refresh()"
                    class="mb-3"
                >
                </b-form-radio-group>
                <b-form-radio-group
                    buttons
                    button-variant="outline-primary"
                    :options="options.status"
                    name="radios-btn-direction"
                    v-model="searchForm.status"
                    @change="pagination.current=1;$refs.table.refresh()"
                    class="mb-3"
                >
                </b-form-radio-group>
          </b-col>
        </div>
        <b-row>
          <b-col offset-sm="10" sm="2" class="mb-3">
            <button type="button" class="btn btn-info btn-block" @click="pagination.current=1;$refs.table.refresh()">
              <i class="fa fa-search"></i> Search
            </button>
          </b-col>
        </b-row>

        <!-- PERMIT TABLE  -->
        <b-table :per-page="pagination.per_page"
                 :current-page="pagination.current"
                 ref="table"
                 id="table"
                 :items="loadPage"
                 :fields="columns"
                 :busy.sync="isLoading"
                 striped
                 borderless
                 outlined
                 hover
                 show-empty
                 empty-text="No records found..."
                 stacked="sm"
                 class="mb-3"
        >
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner label="Loading..." type="grow"></b-spinner>
            </div>
          </template>
          <template #cell(truck)="data">
            {{ data.item.lic_plate != null ? data.item.lic_plate : '' }}
            <b-badge variant="warning" v-if="data.item.company != null" >
              {{ data.item.company }}
            </b-badge>
          </template>
          <template #cell(containers)="data">
          
            <span v-if="typeof data.value === 'object'" >
              <span v-for="(con, idx) in ([].concat(data.value.container))" :key="con.no || idx">
                {{ con.no }}&nbsp;
                <b-badge variant="info">{{ con.voyage }}</b-badge>
              </span>
            </span>

          </template>
          <template #cell(gate)="data">
            <span v-if="data.item.pass_status==3">
              <span v-if="typeof data.item.event === 'object'" >
                <b-badge variant="secondary">{{ data.item.event.evt_time.replace(/T/, ' ').slice(0,19) }}</b-badge>
                <b-badge variant="primary" v-if="data.item.direction==1">{{data.item.event.lane}}</b-badge>
                <b-badge variant="danger" v-if="data.item.direction==2">{{data.item.event.lane}}</b-badge>
              </span>
            </span>
            <span v-if="data.item.pass_status<3">
              <span v-if="typeof data.item.event === 'object'" >
                <b-badge variant="primary" v-if="data.item.direction==1">IN</b-badge>
                <b-badge variant="danger" v-if="data.item.direction==2">OUT</b-badge>
              </span>
            </span>
          </template>
          <template #cell(actions)="data">
            
            <b-button squared variant="primary btn-sm" @click="openDocumentModal(data.item)">Documents</b-button>
            <b-button squared variant="info btn-sm" @click="showQRModal(data.item)">QRCODE</b-button>
            <b-button squared variant="secondary btn-sm" @click="copyToClipboard(data.item.pass_code)" ><i class="bi bi-clipboard-plus"></i></b-button>
          </template>
        </b-table>
        <div class="form-group row justify-content-end">
          <label class="col-sm-1 col-form-label">Per Page</label>
          <div class="col-sm-1 mb-3">
            <b-form-select
                :value="pagination.per_page"
                :options="options.pagination"
                @change="(v) => {pagination.per_page = v; pagination.current = 1}"
            ></b-form-select>
          </div>
          <div class="pr-2">
            <simple-pagination
                v-model="pagination.current"
                :disable-prev="pagination.current === 1"
                :disable-next="pagination.at_last_page"
            />
          </div>
        </div>
      </b-card>
    </Content>


    <!-- PERMIT FORM  -->
    <b-modal
        centered
        header-bg-variant="info"
        id="permitModal" size="lg"
        :title="'Permit Form ' + (this.permit.company !==undefined ? this.permit.company : '')"
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
    >
      <b-row>
        <b-col v-if="can('superadmin|control_room')">
          <b-form-group
              label="Owner"
              label-for="owner_name"
          >
          
            <!-- owner permit -->
            <MemberDropDown v-model="$v.owner.$model"
                            v-if="!isReadOnly"
                            :state="validateState('owner')"
        
                            type='tes'
                            @input="loadVehicleByMember"
            ></MemberDropDown>

            <b-form-input
                v-else
                :disabled="isReadOnly"
                id="owner_name"
                :readonly="isReadOnly"
                v-model="owner.company_name"
                autocomplete="off"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="Vehicle"
            label-for="lic_plate"
            label-class="required"
          >
            <b-skeleton-wrapper :loading="isLoadingVehicle">
              <template #loading>
                <b-skeleton type="input"></b-skeleton>
              </template>
              <!-- Gunakan value di option! -->
              <b-form-input
                :disabled="options.memberVehicles.length === 0"
                id="lic_plate"
                list="vehicle-list"
                v-model="$v.permit.lic_plate.$model"
                required
                :state="validateState('permit', 'lic_plate')"
                :readonly="readonly.lic_plate"
                autocomplete="off"
                v-uppercase
              ></b-form-input>
              <b-form-invalid-feedback>
                This field is required
              </b-form-invalid-feedback>
              <datalist id="vehicle-list">
                <option
                  v-for="vehicle in options.memberVehicles"
                  :key="vehicle.id"
                  :value="vehicle.lic_plate">
                  {{ vehicle.lic_plate }}
                </option>
              </datalist>
            </b-skeleton-wrapper>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
              label="Date"
              label-for="date"
              label-class="required"
          >
            <b-form-datepicker
                id="date"
                :date-disabled-fn="disabledDate"
                :aria-disabled="isReadOnly"
                :aria-readonly="isReadOnly"
                v-model="$v.permit.permit_date.$model"
                locale="en-US"
                :state="validateState('permit', 'permit_date')"
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            ></b-form-datepicker>
            <b-form-invalid-feedback>
              This field is required
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="5">
          <b-form-group class="d-block"
                        label-for="direction"
                        label-class="required"
                        label="Type"
                        :disabled="isReadOnly"
                        :state="validateState('permit', 'direction')"
          >
            <b-form-radio-group
                v-model="cargoType"
                :options="options.cargo"
                name="radios-btn-cargo"
                :disabled="isReadOnly"
                @change="changeCargoType($event)"
            >
            </b-form-radio-group>

            <b-form-radio-group
                v-model="containerType"
                :options="options.containerType"
                name="radios-btn-direction"
                :state="validateState('permit', 'direction')"
                :disabled="isReadOnly"
                class="invisible"
                id="radio-container-type"
                @change="changeContainerType($event)"
            >
              <b-form-invalid-feedback :state="validateState('permit', 'direction')">
                This field is required
              </b-form-invalid-feedback>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
            <b-collapse
            id="collapse-container" 
            v-model="isContainerVisible"
          >
            <b-form-group
                label="Container"
                label-for="best"
            >
              <b-input-group>
                <b-form-input
                    id="best"
                    v-model.trim="$v.container.$model"
                    type="text"
                    :state="validateState('container')"
                    maxLength="15"
                    disabled
                    v-uppercase
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                  v-if="!isNullContainer"
                  variant="primary"
                            @click="addContainerToList"
                            :disabled="addingToContainer || permit.container.length === 2"
                  >
                    <i class="fa fa-plus" v-if="!addingToContainer"></i>
                    <i class="fa fa-refresh spinner-border spinner-border-sm" v-else></i>
                  </b-button>
                </b-input-group-append>
                <b-form-invalid-feedback>
                  This field is required and its max length is 15 characters
                </b-form-invalid-feedback>
              </b-input-group>
            </b-form-group>

            <div class="d-flex mb-3" v-if="isNullContainer">
              <b-form-radio-group
              class="mt-2"
              v-model="valueDir"
              :options="options.directions"
              name="radios-btn-directions"
              :disabled="isReadOnly"
          >
          </b-form-radio-group> 
              <b-button
                            
              variant="primary"
                        @click="addContainerToList"
                        :disabled="addingToContainer || permit.container.length === 2"
              >
                <i class="fa fa-plus" v-if="!addingToContainer"></i>
                <i class="fa fa-refresh spinner-border spinner-border-sm" v-else></i>
              </b-button>
            </div>
          
            <b-table
                ref="container"
                id="container"
                :items="permit.container"
                :fields="permitContainer"
                striped
                borderless
                outlined
                hover
                show-empty
                empty-text="Empty container list..."
                stacked="sm"
                class="mb-3 "
            >
              <template #cell(action)="data">
                <b-button variant="primary"
                          size="sm"
                          class="mr-3"
                          @click="showContainerInfo({ containers: data.item, direction: permit.direction, status: permit.pass_status })"
                >
                  <i class="fa fa-receipt"></i>
                  Documents
                </b-button>
                <b-button variant="danger"
                          size="sm"
                          v-if="!isReadOnly"
                          @click="permit.container.splice(data.index,1)"
                >
                  <i class="fa fa-trash"></i>
                  Delete
                </b-button>
              </template>
            </b-table>
          </b-collapse>

          <b-row v-if="!addingToContainer && !!permit.event">
            <b-col>
              <b-badge pill variant="secondary">{{permit.event.lane}}</b-badge>
              <b-badge pill variant="secondary">{{permit.event.evt_time | timestamp}}</b-badge>
            </b-col>
          </b-row>
      <template #modal-footer="{ ok, cancel, }">
        <b-button variant="primary"
                  @click="continueToContainerDocuments()"
                  :disabled="isSubmitting || (isContainerVisible && permit.container.length === 0)"
                  v-if="!isReadOnly"
        >
          Save
          <b-spinner v-if="isSubmitting" small></b-spinner>
        </b-button>
        <b-button variant="secondary" @click="cancel(); clearForm(); ">
          Cancel
        </b-button>
      </template>
    </b-modal>


    <!-- SPPB Document Modal   -->
    <b-modal
        header-bg-variant="secondary"
        id="sppb" size="xl"
        title="Dokumen Pabean"
        no-close-on-esc
        hide-header-close
        no-close-on-backdrop>
        <span v-for="con in containers" :key="con.no">
          <b-badge variant="info">
            {{ con.no }}
          </b-badge>
          <b-badge variant="secondary">
            {{ con.voyage }}
          </b-badge>
          <template v-if="!containerIsLoading">
            <b-table
              :items="Array.isArray(con.docs) ? con.docs : [con.docs]"
              :fields="containerColumns"
              responsive
              striped
              borderless
              outlined
              hover
              stacked="sm">
            </b-table>
          </template>
          <b-skeleton-wrapper :loading="!containerIsLoading">
            <b-skeleton-table
              :rows="5"
              :columns="containerColumns.length"
              :hideHeader="false"
              :table-props="{ bordered: false, striped: true, outlined: true, hover: true, fields: columns, stacked: 'sm' }"
            ></b-skeleton-table>
          </b-skeleton-wrapper>
        </span>

      <template #modal-footer="{ ok, cancel, }">
        <b-button v-if="!showContainerInfoOnly" variant="secondary" @click="$bvModal.show('permitModal');cancel()">
          Close
        </b-button>
        <b-button v-if="canCancel" variant="danger" @click="$bvModal.show('cancelConfirmation');canCancel=false;cancel()">
          <i class="fa fa-trash"></i> Cancel this permit!
        </b-button>
        <b-button v-if="showContainerInfoOnly" variant="primary" @click="cancel()">
          Close
        </b-button>
      </template>
    </b-modal>
    <!-- QRCODE Modal old -->
    <b-modal header-bg-variant="success"
             id="qrModalold"
             :title="(`${selectedPermit.company===undefined?'':selectedPermit.company.toUpperCase()} - `) + (selectedPermit.lic_plate===undefined?'':selectedPermit.lic_plate.toUpperCase())"
             ok-only
             no-close-on-backdrop>
      <h4 class="text-center text-bold text-uppercase">
        {{ selectedPermit.company }}
      </h4>
      <h2 class="text-center">
        {{ selectedPermit.permit_date.replace(/\+.*/, '') }}
      </h2>
      <h1 class="text-center text-uppercase text-bold">
        {{ selectedPermit.direction.toString() === '1' ? 'IN': 'OUT' }}
      </h1>
      <b-link target="_blank" :href="qrcode" @click="copyToClipboard(selectedPermit.pass_code)">
        <b-img :src="qrcode" fluid center></b-img>
      </b-link>

      <h1 class="text-center text-bold text-uppercase">
        {{ selectedPermit.lic_plate }}
      </h1>
      <h2 class="text-center text-uppercase" v-if="selectedPermit.containers!==undefined">
        <ul class="list-group list-group-flush" v-if="selectedPermit.containers!==null">
          <li class="list-group-item" v-for="(container,i) in selectedPermit.containers.container" :key="i">{{ container===undefined?'':container.no }}</li>
        </ul>
      </h2>
      <h2 class="text-center" v-else>
        -
      </h2>
      <template #modal-footer="{ ok, }">
        <b-button @click="qrcode=null;selectedPermit={lic_plate: '',container: '', direction: '', permit_date: '',};ok();" block variant="primary">
          OK!
        </b-button>
      </template>
    </b-modal>

    <!-- QRCODE Modal -->
    <b-modal header-bg-variant="success"
            size="xl"
             id="qrModal"
             :title="(`${selectedPermit.company===undefined?'':selectedPermit.company.toUpperCase()} - `) + (selectedPermit.lic_plate===undefined?'':selectedPermit.lic_plate.toUpperCase())"
             ok-only
             no-close-on-backdrop>
      <div class="d-flex flex-lg-row flex-column justify-content-between gap-5">
        <div class="flex-fill border border-5 border-danger p-2">
          <h4 class="text-center text-bold text-uppercase">
            {{ selectedPermit.company }}
          </h4>
          <h2 class="text-center">
            {{ selectedPermit.permit_date.replace(/\+.*/, '') }}
          </h2>
          <div>
            <h1 class="text-danger text-center text-uppercase text-bold">{{ `IN`+radio_ctr }}</h1>
            <h5 class="text-center text-bold">{{ radio_ctr == ' SP2' ? 'Surat Penyerahan Petikemas' : (radio_ctr == ' RC' ? 'Receiving Card / Kartu Muat':'') }}</h5>
          </div>
          <b-link target="_blank" :href="qrcode" @click="copyToClipboard(selectedPermit.pass_code)">
            <b-img :src="qrcode" fluid center></b-img>
          </b-link>
          
          <h1 class="text-center text-bold text-uppercase">
            {{ selectedPermit.lic_plate }}
          </h1>

          <h5 class="text-center text-uppercase" v-if="selectedPermit.containers!==undefined">
            <template v-if="selectedPermit.containers !== null">
              <ul class="list-group mt-4" v-for="(container, i) in selectedPermit.containers.container" :key="'in'+i">
                <li class="list-group-item">
                  <h4><b>{{ container === undefined ? '' : 'No. Container : ' + container.no }}</b></h4>
                </li>
                <li class="list-group-item">
                  <b>{{ container === undefined ? '' : 'Vessel / Voy : ' + container.vessel + ' / ' + container.voyage }}</b>
                </li>
                <li class="list-group-item">
                  <b>
                    {{
                      container === undefined
                        ? ''
                        : (
                            radio_ctr === ' SP2'
                              ? 'Block / Slot / Row / Tier : ' + container.block + ' / ' + container.slot + ' / ' + container.row + ' / ' + container.tier
                              : 'Block / Slot : ' + container.block + ' / ' + container.slot
                          )
                    }}
                  </b>
                </li>
              </ul>
            </template>

            <div class="d-flex justify-content-center mt-5">
              <div class="d-flex flex-column">
                <div class=""><b>Expired</b> {{selectedPermit.expired}}</div>
                <!-- <div>{{ cargoType.toString() }}</div> -->
              </div>
            </div>
          </h5>
          <h5 class="text-center" v-else>
            -
          </h5>
        </div>
        <div class="p-2"></div>
        <div class="flex-fill border border-5 border-success p-2">
          <h4 class="text-center text-bold text-uppercase">
            {{ selectedPermit2.company }}
          </h4>
          <h2 class="text-center">
            {{ selectedPermit2.permit_date.replace(/\+.*/, '') }}
          </h2>
          <div>
            <h1 class="text-success text-center text-uppercase text-bold">{{ `OUT`+radio_ctr }}</h1>
            <h5 class="text-center text-bold">{{ 
              radio_ctr == ' SP2' ? 'Surat Penyerahan Petikemas' : (radio_ctr == ' RC' ? 'Receiving Card / Kartu Muat':'') }}</h5>
          </div>
          <b-link target="_blank" :href="qrcode2" @click="copyToClipboard(selsp2ectedPermit2.pass_code)">
            <b-img :src="qrcode2" fluid center></b-img>
          </b-link>
          <h1 class="text-center text-bold text-uppercase">
            {{ selectedPermit2.lic_plate }}
          </h1>
          <h5 class="text-center text-uppercase" v-if="selectedPermit2.containers!==undefined">
            <template v-if="selectedPermit2.containers !== null">
              <ul class="list-group mt-4" v-for="(container2, i) in selectedPermit2.containers.container" :key="'out'+i">
                <li class="list-group-item">
                  <h4><b>{{ container2===undefined ? '' : 'No. Container : ' + container2.no }}</b></h4>
                </li>
                <li class="list-group-item">
                  <b>{{ container2===undefined ? '' : 'Vessel / Voy : ' + container2.vessel + ' / ' + container2.voyage }}</b>
                </li>
                <li class="list-group-item">
                  <b>
                    {{
                      container2 === undefined
                        ? ''
                        : (
                            radio_ctr === ' SP2'
                              ? 'Block / Slot / Row / Tier : ' + container2.block + ' / ' + container2.slot + ' / ' + container2.row + ' / ' + container2.tier
                              : 'Block / Slot : ' + container2.block + ' / ' + container2.slot
                          )
                    }}
                  </b>
                </li>
              </ul>
            </template>
            <div class="d-flex justify-content-center mt-5">
              <div class="d-flex flex-column">
                <div class=""><b>Expired</b> {{selectedPermit2.expired}}</div>
              </div>
            </div>
          </h5>
          <h5 class="text-center" v-else>
            -
          </h5>

        </div>
      </div>
      
      <template #modal-footer="{ ok, }">
        <b-button @click="
          qrcode=null;
          qrcode2=null;
          selectedPermit={lic_plate: '',container: '', direction: '', permit_date: '', vessel: '', expired: ''};
          selectedPermit2={lic_plate: '',container: '', direction: '', permit_date: '',vessel: '', expired: ''};
          radio_ctr='';
          ok();" 
          block variant="primary">
          OK!
        </b-button>
      </template>
    </b-modal>
    
    <!-- QRCODE Modal2 -->
    <b-modal header-bg-variant="success"
             id="qrModal2"
             :title="(`${selectedPermitModal2.company===undefined || selectedPermitModal2.company == null ?'': selectedPermitModal2.company.toUpperCase()} - `) + (selectedPermitModal2.lic_plate===undefined?'':selectedPermitModal2.lic_plate.toUpperCase())"
             ok-only
             no-close-on-backdrop>
            
      <h4 class="text-center text-bold text-uppercase">
        {{ selectedPermitModal2.company }}
      </h4>
      <h2 class="text-center">
        {{ selectedPermitModal2.permit_date.replace(/\+.*/, '') }}
      </h2>
      <h1 class="text-center text-uppercase text-bold">
        {{ `${selectedPermitModal2.direction}` == "1" ? 'IN '+sp2_or_rc: 'OUT '+sp2_or_rc }}
      </h1>
      <b-link target="_blank" :href="qrcode" @click="copyToClipboard(selectedPermitModal2.pass_code)">
        <b-img :src="`static/qrcode/${selectedPermitModal2.pass_code}`" fluid center></b-img>
      </b-link>
      <h1 class="text-center text-bold text-uppercase">
        {{ selectedPermitModal2.lic_plate }}
      </h1>
      <h5 class="text-center text-uppercase" v-if="selectedPermitModal2.containers!==undefined">
        <template v-if="selectedPermitModal2.containers !== null">
          <ul 
            class="list-group mt-4"
            v-for="(container,i) in tmpQRCodeIndex"
            :key="'disp'+i"
          >
            <li class="list-group-item">
              <h4><b>{{ container===undefined?'':'No. Container : '+container.container_no }}</b></h4>
            </li>
            <li class="list-group-item">
              <b>{{ container===undefined?'':'Vessel / Voy : '+container.vessel+' / '+container.voyage }}</b>
            </li>
            <li class="list-group-item">
              <b>
                {{
                  container === undefined
                  ? ''
                  : (
                      container.import_export === 'import'
                        ? 'Block / Slot / Row / Tier : '+container.block+' / '+container.slot+' / '+container.row+' / '+container.tier
                        : 'Block / Slot : '+container.block+' / '+container.col
                    )
                }}
              </b>
            </li>
          </ul>
        </template>
        <div class="d-flex justify-content-center mt-4">
          <div class="d-flex flex-column">
            <div class=""><b>Expired</b> {{selectedPermitModal2.expired}}</div>
          </div>
        </div>
      </h5>
      <h5 class="text-center" v-else>
        -
      </h5>
      
      <template #modal-footer="{ ok, }">
        <b-button @click="
          qrcode=null;
          selectedPermitModal2={lic_plate: '',container: '', direction: '', permit_date: '', vessel: '', expired: ''};
          tmpQRCodeIndex=[];
          
          ok();" 
          block variant="primary">
          OK!
        </b-button>
      </template>
    </b-modal>
    
    <!-- QRModal Old -->
    <b-modal header-bg-variant="success"
          id="qrModal2_old"
          :title="(`${selectedPermitModal2.company===undefined || selectedPermitModal2.company == null ?'': selectedPermitModal2.company.toUpperCase()} - `) + (selectedPermitModal2.lic_plate===undefined?'':selectedPermitModal2.lic_plate.toUpperCase())"
          ok-only
          no-close-on-backdrop>
        
      <h4 class="text-center text-bold text-uppercase">
      {{ selectedPermitModal2.company }}
      </h4>
      <h2 class="text-center">
      {{ selectedPermitModal2.permit_date.replace(/\+.*/, '') }}
      </h2>
      <h1 class="text-center text-uppercase text-bold">
      {{ `${selectedPermitModal2.direction}` == "1" ? 'IN': 'OUT' }}

      </h1>
      <b-link target="_blank" :href="qrcode" @click="copyToClipboard(selectedPermitModal2.pass_code)">
      <b-img :src="`static/qrcode/${selectedPermitModal2.pass_code}`" fluid center></b-img>
      </b-link>
      <h1 class="text-center text-bold text-uppercase">
      {{ selectedPermitModal2.lic_plate }}
      </h1>
      <h2 class="text-center text-uppercase" v-if="selectedPermitModal2.containers!==undefined">
      <ul class="list-group list-group-flush" v-if="selectedPermitModal2.containers!==null">
        <li class="list-group-item" v-for="container in selectedPermitModal2.containers.container" :key="container">
          {{ container===undefined?'':container.no }}
        </li>
      </ul>
      </h2>
      <h5 class="text-center" v-else>
      -
      </h5>

      <template #modal-footer="{ ok, }">
      <b-button @click="
      qrcode=null;
      selectedPermitModal2={lic_plate: '',container: '', direction: '', permit_date: '', vessel: '', expired: ''};
      tmpQRCodeIndex=[];
      
      ok();" 
      block variant="primary">
      OK!
      </b-button>
      </template>
    </b-modal>

    <!-- Cancel Confirmation Modal -->
    <b-modal header-class="bg-danger text-white" id="cancelConfirmation">
      <template #modal-title>
        <b-icon icon="exclamation-triangle-fill"></b-icon>
        Cancel Permit Confirmation
      </template>
      <h1 class="text-center font-weight-bolder">WARNING!</h1>
      <h4 class="text-center">This destructive action is not recoverable! </h4>
      <h4 class="text-center">Are you sure to cancel this permit?</h4>
      <b-form-group
          label="Reason"
          label-for="reason"
          label-class="required"
      >
        <b-form-input
            id="reason"
            v-model="$v.cancellationForm.desc.$model"
            :state="validateState('cancellationForm','desc')"
            type="text"
            required
            placeholder="Enter your cancellation reason"
        ></b-form-input>
        <b-form-invalid-feedback>
          This is a required field and max 70 characters.
        </b-form-invalid-feedback>
      </b-form-group>
      <template #modal-footer="{ ok, cancel, hide }">
        <b-button size="sm" variant="outline-danger" @click="cancelPermit(selectedPermit)" :disabled="isCancelling">
          <i class="fa fa-trash"></i>
          Yes, Cancel it!
          <b-spinner v-if="isCancelling" small></b-spinner>
        </b-button>
        <b-button size="sm" variant="secondary" @click="$v.$reset();hide('forget')">
          Nah, I've changed my mind
        </b-button>
      </template>
    </b-modal>
  </content-wrapper>
</template>

<script>
import ContentWrapper from "@/components/Layouts/ContentWrapper";
import Content from "@/components/Layouts/Content";
import {listPermit, addPermit, listPermitByVehicle, setPermitStatus} from '@/services/permits';
import {
  BIcon, BIconExclamationTriangleFill, BSkeletonTable,
  BSkeletonWrapper, BFormDatepicker,
  BIconPlusCircleFill, BImg, BLink
} from 'bootstrap-vue'
import {lookupVehicle} from "@/services/vehicles";
import {listBSIMSdoc} from "@/services/bsims";
import {findContainerLocal} from "@/services/bsims";
import {rspValidateBtos, rspQrCodeToBtos, gateCorrection, getSavedPermit} from "@/services/btos";
import {getDetailQR} from "@/services/persero_btm";
import {userInfoMixin} from "@/mixins/userInfoMixin";
import SimplePagination from "@/components/SimplePagination";
import {validationMixin} from "vuelidate";
import {formValidation} from "@/mixins/formValidation";
import {required, maxLength,} from "vuelidate/lib/validators";
import Str from "@/helpers/Str";
import MemberDropDown from "@/components/composable/MemberDropDown";
import {optionalMixin} from "@/mixins/optional";
import {hasOwnProperty, isString} from "@/helpers/Utils";

export default {
  name: "Permits",
  components: {
    SimplePagination,
    Content, ContentWrapper,
    BSkeletonTable,
    BIcon, BImg,
    BSkeletonWrapper,
    BFormDatepicker,
    // eslint-disable-next-line vue/no-unused-components
    BIconPlusCircleFill, BIconExclamationTriangleFill,
    MemberDropDown, BLink
  },
  mixins: [
    userInfoMixin, validationMixin, formValidation,
    optionalMixin,
  ],
  validations: {
    cancellationForm: {
      desc: {
        required,
        maxLength: maxLength(70),
      }
    },
    container: {
      required,
      maxLength: maxLength(15),
    },
    permit: {
      lic_plate: {
        required,
        maxLength: maxLength(9),
      },
      permit_date: {
        required,
      },
      direction: {
        // required,
      },  // 1=in 2=out
    },
    owner: {
      required,
    }
  },
  data() {
    return{
    sp2_or_rc:'',
    tmpQRCodeIndex:[],
    old_new:'',

    isNullContainer : false,
    valueDir :'',

    // old
    container_info: {},
    isLoading: false,
    permits: [],

    columns: [
      {
        key: 'permit_date',
        label: 'Tanggal',
        formatter: x => typeof x === 'string' ? x.replace(/\+.*/, '') : '-',
      },
      {
        key: 'truck',
        label: 'Trucking',
      },
      {
        key: 'containers',
        label: 'Container [voy]',
      },
      {
        key: 'gate',
        label: 'Gate',
      },
//      {
//        key: 'direction',
//        label: 'Arah',
//        formatter: x => x === 1 ? 'IN' : 'OUT',
//      },
//      {
//        key: 'event.lane',
//        label: 'jalur',
//        formatter: x => typeof x === 'string' ? x : '-',
//      },
//      {
//        key: 'event.evt_time',
//        label: 'waktu',
//        formatter: x => typeof x === 'string' ? x.replace(/T/, ' ').slice(0,19) : '-',
//      },
      {
        key: 'actions',
        label: 'Actions',
      }
    ],
    pagination: {
      current: 1,
      last_page: 15,
      total_items: 0,
      per_page: 10,
      at_last_page: false,
    },
    permit: {
      lic_plate: "",
      //container: "",
      permit_date: "",
      direction: '',  // 1=in 2=out
      cond: 1,  // 1=kosong 2=isi
      container: [],
    },
    btos_sp2rc: {
      direction: '',
      id: '',
      qr_code: '',
      exim: '',
      vessel: '',
      container: '',
      voyage: '',
      block: '',
      slot: '',
    },
    status: {
      false: 'danger', true: 'primary',
    },
    options: {
      directions: [
        {text: 'IN', value: 1},
        {text: 'OUT', value: 2},
      ],
      condition: [
        {text: 'KOSONG', value: 1},
        {text: 'ISI', value: 2},
      ],
      cargo: [
        {text: 'GENERAL CARGO',value: true},
        {text: 'CONTAINER', value: false},
      ],
      containerType: [
        {text: 'AMBIL (SP2)', value: true},
        {text: 'ANTAR (RC)', value: false},
      ],
      members: [],
      memberVehicles: [],
      search: [
        {text: '', value: ''},
        {text: 'Container', value: 'container'},
        {text: 'License Plate', value: 'lic_plate'},
      ],
      filterDate: [
        {text: '', value: ''},
        {text: 'Gate', value: 'event_time'},
        {text: 'Permit', value: 'permit'},
        {text: 'Activity', value: 'created_at'},
      ],
      pagination: [
        10,
        20,
        30,
        40,
        50,
        80,
        100,
      ],
      status: [
        {text: 'Hold', value: 0},
        {text: 'Active', value: null},
        {text: 'Used', value: 3},
      ],
    },
    owner: null,
    isLoadingVehicle: false,
    containerIsLoading: false,
    containerColumns: [
      {
        key: 'bsims_id',
        label: 'BSIMS',
      },
      {
        key: 'sppb_no',
        label: 'Dok.Pabean',
      },
      {
        key: 'sppb_date',
        label: 'Date',
        formatter: x => x.replace(/1970-01-01\+.*|\+.*/, '')
      },
      {
        key: 'consignee',
        label: 'Consignee',
      },
      {
        key: 'do_no',
        label: 'No. DO',
      },
      {
        key: 'no_bl_awb',
        label: 'No. BL AWB',
      },
      {
        key: 'spj_no',
        label: 'No. SP2',
      },
/*
      {
        key: 'actions',
        label: 'Actions',
      },
 */
    ],
    container: '',
    containers: [],
    documents: [],
    isSubmitting: false,
    selectedDocument: null,
    canAddPermit: false,
    qrcode: '',
    qrcode2: '',
    readonly: {
      lic_plate: true,
    },
    showContainerInfoOnly: false,
    isLoadingMember: false,
    searchForm: {
      keywords: null,
      type: null,
      dateType: null,
      startDate: null,
      endDate: null,
      direction: null,
      condition: null,
      status: null,
    },
    selectedPermitModal2:{
      lic_plate: '',
      containers: {
        container: [],
      },
    //container: [],
      permit_date: '',
      direction: '',
      company: '',
      vessel: '',
      expired: '',
    },
    selectedPermit: {
      lic_plate: '',
      containers: {
        container: [],
      },
    //container: [],
      permit_date: '',
      direction: '',
      company: '',
      vessel: '',
      expired: '',
    },
    selectedPermit2: {
      lic_plate: '',
      containers: {
        container: [],
      },
      permit_date: '',
      direction: '',
      company: '',
      vessel: '',
      expired: '',
    },
    cancellationForm: {
      desc: '',
    },
    isCancelling: false,
    permitContainer: [
      {
        key: 'no',
        label: 'Container',
      },
      {
        key: 'voyage',
        label: 'Voyage',
      },
      {
        key: 'vessel',
        label: 'Vessel',
      },
      {
        key: 'action',
        label: 'Action',
      },
    ],
    cargoType: true,
    containerType: true,
    radio_ctr: ' SP2',
    canCancel: false,
    isContainerVisible: false,
    isReadOnly: false,
    allMembers: [],
    addingToContainer: false,
    }},                                                     
  methods: {
    disabledDate(date) {
      const today = new Date()
        .toISOString()
        .split('T')[0];
      return date < today;
    },
    changeContainerType(e){
      console.log('changeContainerType',e);
    },
    changeCargoType(){
      console.log('cargoType',this.cargoType)
      if(this.cargoType){
        // Set value jadi kosong
        document.getElementById('best').value = '';

        // Disable input
        document.getElementById('best').disabled = true;

        this.permit.container=[];
        this.isContainerVisible = false;

        document.getElementById('radio-container-type').classList.add('invisible');
        document.getElementById('radio-container-type').classList.remove('visible');

      }else{
        document.getElementById('best').value = '';
        document.getElementById('best').disabled = false;

        this.isContainerVisible = true;
        const el = document.getElementById('radio-container-type');
        el.classList.add('visible');
        el.classList.remove('invisible');
      } 
    },
    async loadPage(ctx) {
      this.isLoading = true;
      this.pagination.total_items = 0;
      this.pagination.at_last_page = false;
      try {
        const {data: {data: {rows}}} = await listPermit(this.searchParams(ctx));
        this.isLoading = false;
        const items = Array.isArray(rows.permit) ? rows.permit : [rows.permit];
        this.pagination.total_items = items.length
        this.pagination.at_last_page = this.pagination.total_items < this.pagination.per_page;
        
        return items;
      } catch (e) {
        this.isLoading = false;
        this.pagination.at_last_page = true;
        return [];
      }
    },
    openPermitForm(permit) {
      // console.log(this.data);
      this.isNullContainer = false;
      this.clearForm()
      this.options.memberVehicles = [];
      if (this.can('memberadmin|member')) {
        this.owner = {
          id: this.member.id,
          company_name: this.member.company_name,
//          company_name: permit.company,
        }
        this.$nextTick(() => {
          this.$v.owner.$touch()
        });
        this.loadVehicleByMember()
      }
      if (permit !== undefined) {
        this.isReadOnly = true;
        this.$v.permit.$model = { ... permit};
        this.permit.permit_date = this.permit.permit_date.replace(/\+.*/, '')
        let container = this.optional(this.permit, 'container', []);
        if (container && isString(container)) {
          container = [container]
        }
        this.permit.container = container.map(c => ({ container: c }))

//        this.$v.owner.$model = permit.company;
//        this.$bvToast.toast(`INFO:  ${value} ${permit.member}`, {
//          title: 'Show field value !',
//          autoHideDelay: 1500,
//          variant: 'danger',
//        })

//        if (this.allMembers.length > 0) {
//          const { value } = this.allMembers.find(m => m.value.id === permit.member)
//          this.$v.owner.$model = value;
//        }
        this.isContainerVisible = true;
      }
      this.$bvModal.show('permitModal')
    },
    openDocumentModal(permit) {
      this.selectedPermit = { ...permit};
      console.log(this.selectedPermit);
      if ( this.selectedPermit.containers === null ) {
        this.$bvToast.toast(`No Container !`, {
          title: 'Error!',
          autoHideDelay: 1500,
          variant: 'danger',
        })
        return;
      }

      this.permit.container = Array.isArray(this.selectedPermit.containers.container) ? this.selectedPermit.containers.container.join(',') : this.selectedPermit.containers.container;
      this.showContainerInfoOnly = this.canCancel = true;
      if( this.selectedPermit.event === null ) {
        console.log('select null')
        this.showContainerInfo({ 
          containers: this.selectedPermit.containers, 
          direction: this.selectedPermit.direction, 
          status: this.selectedPermit.pass_status });
      } else {
        console.log('select NOT null')
        this.showContainerInfo({ 
          containers: this.selectedPermit.containers, 
          direction: this.selectedPermit.direction, 
          status: this.selectedPermit.pass_status, 
          event: this.selectedPermit.event.id });
      }
    },
    async addPermit() {
      if (!this.canAddPermit) {
        this.$bvToast.toast(`You are not allowed to add Permit!`, {
          title: 'Error!',
          autoHideDelay: 1500,
          variant: 'danger',
        })
        return;
      }

      // comment1 this to test
      this.$v.permit.$touch();
      if (this.$v.permit.$anyError) {
        this.$bvToast.toast(`Missing required information!`, {
          title: 'Error!',
          autoHideDelay: 1500,
          variant: 'danger',
        })
        return;
      }

      // double in qrcode
      

      this.isSubmitting = true;

      try {
        // Some fields are default from now, refer to addPermit service and see for default value
        // @see @/services/permit.js
        console.log('containerType',this.containerType);
        console.log(' permit.container',this.permit.container);
        this.radio_ctr = this.cargoType == true ? '' : (this.containerType ? ' SP2': ' RC');
        
        const ctr_type = this.cargoType == true
        ? '' : (
          this.containerType == true || this.containerType == false 
          ? this.containerType : ''
          );
        console.log('ctr_type', ctr_type);

        this.permit.direction = 1; //in
        const data = { ... this.permit };
        this.permit.direction = 2; //out
        const data2 = { ... this.permit };

        data.user_id = this.loggedInUser.id; //in
        data.user_name = this.loggedInUser.username
        data2.user_id = this.loggedInUser.id; //out
        data2.user_name = this.loggedInUser.username
        console.log('this.radio_ctr',this.radio_ctr);
        console.log('data',data);
        console.log('data2',data2);

        /* here to test without esb */
        
        const {data: {data: {pass}}} = await addPermit(data, ctr_type); //in
        console.log('pass',pass);

        const pass_out = await addPermit(data2, ctr_type); //out
        const pass2 = pass_out.data.data.pass;
        console.log('pass2',pass2);
        
        this.selectedPermit.containers = { container: [] }; //in
        this.selectedPermit2.containers = { container: [] }; //out

        console.log('isArray_in',Array.isArray(data.container));
        console.log('data.container_in',data.container);

        this.selectedPermit.containers.container = data.container.length != 0 ? data.container.map((item)=>{
              return{
                ...item
              }}) : data2.container.map((item)=>{
              return{
                ...item
              }})
        this.selectedPermit2.containers.container = data.container.length != 0 ?data.container.map((item)=>{
              return{
                ...item
              }}) : data2.container.map((item)=>{
              return{
                ...item
              }})
        
        console.log('data IN',this.selectedPermit,"data2 OUT", this.selectedPermit2);
        
        this.selectedPermit.lic_plate = this.permit.lic_plate;
        this.selectedPermit2.lic_plate = this.permit.lic_plate;

        // this.selectedPermit2.lic_plate = "BP8196DU"; //TEST
        // this.selectedPermit.lic_plate = "BP8196DU";

        this.selectedPermit.block = data?.block ?? "";
        this.selectedPermit2.block = data?.block ?? "";
        this.selectedPermit.slot = data?.slot ?? "";
        this.selectedPermit2.slot = data?.slot ?? "";
        this.selectedPermit.row = data?.row ?? "";
        this.selectedPermit2.row = data?.row ?? "";
        this.selectedPermit.tier = data?.tier ?? "";
        this.selectedPermit2.tier = data?.tier ?? "";

        this.selectedPermit.direction = data.direction;
        this.selectedPermit2.direction = data.direction;

        this.selectedPermit.company = this.owner.company_name;
        this.selectedPermit2.company = this.owner.company_name;

        this.selectedPermit.permit_date = pass.permit_date;
        this.selectedPermit2.permit_date = pass.permit_date;

        // this.selectedPermit.company = "PT PERSERO BATAM"; //TEST
        // this.selectedPermit2.company = "PT PERSERO BATAM";

        // this.selectedPermit.permit_date = "2024-06-07"; //TEST
        // this.selectedPermit2.permit_date = "2024-06-07";

        this.qrcode = `/static/qrcode/${pass.qr_code}`; //prod in
        // this.qrcode = `/static/qrcode/96baje5yzfxc72c6by3rr`; //test in
        
        console.log('isArray_out',Array.isArray(data2.container));
        console.log('data.container_out',data2.container);
        
        this.selectedPermit2.lic_plate = this.permit.lic_plate;
        this.selectedPermit.lic_plate = this.permit.lic_plate;

        // this.selectedPermit2.lic_plate = "BP8196DU"; // TEST
        // this.selectedPermit.lic_plate = "BP8196DU";

        this.selectedPermit2.block = data2?.block ?? "";
        this.selectedPermit.block = data2?.block ?? "";
        this.selectedPermit2.slot = data2?.slot ?? "";
        this.selectedPermit.slot = data2?.slot ?? "";
        this.selectedPermit2.row = data2?.row ?? "";
        this.selectedPermit.row = data2?.row ?? "";
        this.selectedPermit2.tier = data2?.tier ?? "";
        this.selectedPermit.tier = data2?.tier ?? "";

        this.selectedPermit2.direction = data2.direction;
        this.selectedPermit.direction = data2.direction;

        this.selectedPermit2.company = this.owner.company_name;
        this.selectedPermit.company = this.owner.company_name;

        this.selectedPermit2.permit_date = pass2.permit_date;
        this.selectedPermit.permit_date = pass2.permit_date;

        // this.selectedPermit.company = "PT PERSERO BATAM"; //TEST
        // this.selectedPermit2.company = "PT PERSERO BATAM";

        // this.selectedPermit.permit_date = "2024-06-07"; //TEST
        // this.selectedPermit2.permit_date = "2024-06-07";

        this.qrcode2 = `/static/qrcode/${pass2.qr_code}`; //prod out
        // this.qrcode2 = `/static/qrcode/1ngv96m0n1z355n1pszdnv`; //test out
        
        console.log('this.selectedPermit.containers.container',this.selectedPermit.containers.container);

        /* btos store qr-code & container update PROD*/
        if(!this.cargoType){
          const store_qr_code_to_btos = await rspQrCodeToBtos({ //IN
            direction: 1,
            id: this.btos_sp2rc.id,
            qr_code: pass.qr_code,
            exim: this.btos_sp2rc.exim,
          });
          console.log(JSON.parse(store_qr_code_to_btos));

          const store_qr_code_to_btos2 = await rspQrCodeToBtos({ //OUT
            direction: 2,
            id: this.btos_sp2rc.id,
            qr_code: pass2.qr_code,
            exim: this.btos_sp2rc.exim,
          });
          console.log(JSON.parse(store_qr_code_to_btos2));
        }
        /* end btos store qr-code PROD*/

        /* btos store qr-code & container update TEST */
        // if(!this.cargoType){
          // const store_qr_code_to_btos = await rspQrCodeToBtos({
          //   direction:1,
          //   id:this.btos_sp2rc.id,
          //   qr_code:'qr-code-qwertyin',
          //   exim:this.btos_sp2rc.exim,
          // });
          // console.log(JSON.parse(store_qr_code_to_btos));
          
          // const store_qr_code_to_btos2 = await rspQrCodeToBtos({
          //   direction:2,
          //   id:this.btos_sp2rc.id,
          //   qr_code:'qr-code-qwertyout',
          //   exim:this.btos_sp2rc.exim,
          // });
          // console.log(JSON.parse(store_qr_code_to_btos2));
          
          // const update_container_in = await updateContainer({ //test IN
          //   containers: this.selectedPermit.containers.container,
          //   qr: this.qrcode.split('/')[3],
          // });
          // console.log('qr',this.qrcode.split('/'),JSON.parse(update_container_in));

          // const update_container_out = await updateContainer({ //test OUT
          //   containers: this.selectedPermit2.containers.container,
          //   qr: this.qrcode2.split('/')[3],
          // });
          // console.log('qr',this.qrcode2.split('/'),JSON.parse(update_container_out));
        // }

        // expired date
        const getPermitDate = new Date(this.permit.permit_date);
        getPermitDate.setDate(
          (new Date(this.permit.permit_date)).getDate() + 5
        );
        const expired = getPermitDate.toLocaleDateString('id-ID')
          .split('/').join('-');
        
          
        this.selectedPermit.vessel = this.cargoType == false ? this.btos_sp2rc.vessel : ''; // Prod IN
        this.selectedPermit.expired = expired;
          
        this.selectedPermit2.vessel = this.cargoType == false ? this.btos_sp2rc.vessel : ''; // Prod OUT
        this.selectedPermit2.expired = expired;
        
        /* end btos store qr-code TEST */

        this.$bvToast.toast(`Add Permit Success!`, {
          title: 'Congratulation!',
          autoHideDelay: 1500,
          variant: 'success',
        })
        this.$bvModal.hide('permitModal')
        this.$bvModal.hide('sppb');
        this.$bvModal.show('qrModal')
        this.clearForm();
        this.$refs.table.refresh();
      } catch (e) {
        if (!hasOwnProperty(e, 'response')) {
          this.$bvToast.toast(`${e.message}`, {
            title: 'Error!',
            autoHideDelay: 1500,
            variant: 'danger',
          })
          return;
        }
      }
      this.isSubmitting = false;
    },
    clearForm() {
      this.valueDir = ''
      this.container = '';
      this.permit = {
        lic_plate: "",
        // container: "",
        permit_date: "",
        direction: '',  // 1=in 2=out
        cond: 1,  // 1=kosong 2=isi
        container: [],
      }
      this.isContainerVisible = false;
      this.selectedDocument = null;
      this.owner = null;
      this.$nextTick(() => {
        this.$v.$reset();
      });
      this.isReadOnly = false;
      this.cargoType = true;
      this.containerType = true;
    },
    async loadVehicleByMember() {
      
      try {
        this.isLoadingVehicle = true;
        this.readonly.lic_plate = true;
        this.permit.lic_plate = '';

        if(this.owner.text){
          this.owner = this.owner.value
        }

        const {data: {data: {rows}}} = await lookupVehicle({member: this.owner.id});
        this.options.memberVehicles = Array.isArray(rows.vehicle) ? rows.vehicle : [rows.vehicle];
        
        this.readonly.lic_plate = false;
      } catch (e) {

        this.options.memberVehicles = [];

      }
      this.isLoadingVehicle = false;
    },
    // old permit
    async addOldPermit() {
      console.log('addOldPermit')
      console.log('this.permit',this.permit)
      if (!this.canAddPermit) {
        this.$bvToast.toast(`You are not allowed to add Permit!`, {
          title: 'Error!',
          autoHideDelay: 1500,
          variant: 'danger',
        })
        return;
      }
      this.$v.permit.$touch();
      if (this.$v.permit.$anyError) {
        this.$bvToast.toast(`Missing required information!`, {
          title: 'Error!',
          autoHideDelay: 1500,
          variant: 'danger',
        })
        return;
      }
      this.isSubmitting = true;
      try {
        // Some fields are default from now, refer to addPermit service and see for default value
        // @see @/services/permit.js
        const data = { ... this.permit };
        data.user_id = this.loggedInUser.id;
        data.user_name = this.loggedInUser.username
        const {data: {data: {pass}}} = await addPermit(data);
        this.selectedPermit.containers = { container: [] };
        if( data.container != null ) {
          if (!Array.isArray(data.container)) {
            this.selectedPermit.containers.container = [data.container];
          } else {
            this.selectedPermit.containers.container = data.container;
          }
        }

        this.selectedPermit.direction = data.direction;

        this.selectedPermit.lic_plate = this.permit.lic_plate;
        // this.selectedPermit.lic_plate = "BP8196DU"; //TEST

        this.selectedPermit.company = this.owner.company_name;
        // this.selectedPermit.company = "PT PERSERO BATAM"; //TEST

        this.selectedPermit.permit_date = pass.permit_date;
        // this.selectedPermit.permit_date = "2024-06-07"; //TEST

        this.qrcode = `/static/qrcode/${pass.qr_code}`;
        // this.qrcode = `/static/qrcode/1ngv96m0n1z355n1pszdnv`; //test out

        this.$bvToast.toast(`Add Permit Success!`, {
          title: 'Congratulation!',
          autoHideDelay: 1500,
          variant: 'success',
        })
        this.$bvModal.hide('permitModal')
        this.$bvModal.hide('sppb');
        this.$bvModal.show('qrModalold')
        this.clearForm();
        this.$refs.table.refresh();
      } catch (e) {
        if (!hasOwnProperty(e, 'response')) {
          this.$bvToast.toast(`${e.message}`, {
            title: 'Error!',
            autoHideDelay: 1500,
            variant: 'danger',
          })
          return;
        }
      }
      this.isSubmitting = false;
    },
    async continueToContainerDocuments() {
      /**
       * Need extra confirmation from Pak.Halim
       * about how to submit this form
       * since the initial API only accept 1 or non container
       * and now it becomes 1 or 2 or non
       */
      this.canAddPermit = true;

      if (this.isNullContainer) {
        return this.addOldPermit();
      } else {
        return this.addPermit();
      }


     
      // eslint-disable-next-line no-unreachable
      // this.showContainerInfoOnly = false; 
      // this.$v.permit.$touch();
      // if (this.$v.permit.$anyError) {
      //   this.$bvToast.toast(`Missing required information!`, {
      //     title: 'Error!',
      //     autoHideDelay: 1500,
      //     variant: 'danger',
      //   })
      //   return;
      // }
      // if (!this.permit.container) {
      //   // only when the container is empty, it allowed to directly create permit!
      //   this.canAddPermit = true;
      //   return this.addPermit();
      // }
      // this.$bvModal.hide('permitModal')
      // return this.showContainerInfo(this.permit.container);
    },
    async showContainerInfo({ containers, direction, status, event }) {
/*    
      this.$bvToast.toast(`STATUS:  ${containers} ${status}`, {
          title: 'Show field value !',
          autoHideDelay: 1500,
          variant: 'danger',
      })
*/
      console.log('showContainerInfo', containers, direction, status, event);

      this.containerIsLoading = true;
      if (!containers) {
        this.containerIsLoading = false;
        this.documents = [];
        this.canAddPermit = false;
        return;
      }

      this.containers = [];

      for( const c of Array.isArray(containers.container)?containers.container:[containers.container] ) {
        try {
          const {data: {data: {container}}} = event === undefined ?
            await listBSIMSdoc({
              container: c.no,
              voyage: c.voyage,
              direction: direction,
              status: 0,
  //            status: (status === 3 ? 1 : 0 ),
              format: 'container',
            }) :
            await listBSIMSdoc({
              container: c.no,
              voyage: c.voyage,
              direction: direction,
              status: 1,
              event: event,
  //            status: (status === 3 ? 1 : 0 ),
              format: 'container',
            });

          this.containers.push(container);
        
          // if (Array.isArray(container.docs)) {
          //   this.documents = container.docs.map(c => Array.isArray(c.docs) ? c.docs : [c.docs]).flat()
          // } else {
          //   this.container_info = container;
          //   this.documents = Array.isArray(container.docs) ? container.docs : [container.docs];
          // }
          // this.canAddPermit = true;

        } catch (e) {
          console.error(e)
          this.documents = [];
          this.canAddPermit = false;
          return;
        }

      }
      this.$bvModal.show('sppb');
      this.containerIsLoading = false;
    },
    /**
     * this method will be completely removed on next release
     * @deprecated
     * @type {boolean}
     */
    selectDocument(doc) {
      this.selectedDocument = doc;
      this.$bvModal.hide('sppb')
    },
    /**
     * this method will be completely removed on next release
     * @deprecated
     * @type {boolean}
     */
    async search() {
      this.isLoading = true;
      try {
        const {data: {data: {rows}}} = await listPermitByVehicle(this.searchParams());
        this.permits = Array.isArray(rows.permit) ? rows.permit : [rows.permit];
      } catch (e) {
        this.permits = [];
      }
      this.isLoading = false;
    },
    searchParams(ctx) {
      const searchData = {
        per_page: this.pagination.per_page,
        current_page: this.pagination.current,
      };
      if (ctx.sortBy !== '') {
        const direction = ctx.sortDesc ? 'desc' : 'asc';
        searchData['order_by'] = `${ctx.sortBy},${direction}`;
      }
      if (this.selectedMember !== null) {
        searchData['member'] = this.selectedMember.id
      }
      if (this.selectedMember === '' && Object.prototype.hasOwnProperty.call(searchData, 'member')) {
        delete searchData.member
      }
      if (this.searchForm.type) {
        searchData[this.searchForm.type] = `%${this.searchForm.keywords}%`;
      }

      if (this.searchForm.dateType && this.searchForm.startDate) {
        searchData[`${this.searchForm.dateType}_start`] = this.searchForm.startDate;
      }
      if (this.searchForm.dateType && this.searchForm.endDate) {
        searchData[`${this.searchForm.dateType}_end`] = this.searchForm.endDate;
      }
      if (this.searchForm.direction) {
        searchData['direction'] = this.searchForm.direction;
      }
      if (this.searchForm.condition) {
        searchData['cond'] = this.searchForm.condition;
      }
      if (this.searchForm.status !== null) {
        searchData['status'] = this.searchForm.status;
      }
      return searchData;
    },
   async showQRModal(permit) {
    var oldFlag = false;
    this.tmpQRCodeIndex = [];
   
      // console.log(this.selectedPermit);
      if (!hasOwnProperty(permit, 'pass_code')) {
        this.$bvToast.toast(`QRCode does not exists`, {
          title: 'Error!',
          autoHideDelay: 1500,
          variant: 'danger',
        })
        return;
      }
      
      console.log('permit',permit);
      this.selectedPermitModal2 = {...permit};
      console.log('selectedPermitModal2 firssssst',this.selectedPermitModal2);
     
      this.selectedPermitModal2.containers; 
      if( this.selectedPermitModal2.containers !== null ) {
        if (!Array.isArray(this.selectedPermitModal2.containers.container)) {
          this.selectedPermitModal2.containers.container = [this.selectedPermitModal2.containers.container]
        }
        
        this.selectedPermitModal2.containers.container.forEach(async (el) => {

          await getSavedPermit({
            qr: this.selectedPermitModal2.pass_code,
            container_no: el.no ?? "",
          })
          .then((data)=>{
            
            var resData = JSON.parse(data);
            oldFlag = resData.data == null ? true: false;
            console.log("flag old",oldFlag);
            
            console.log("data balikan permit",resData);
            if (resData.data != null) this.tmpQRCodeIndex.push({
              ...resData.data
            });

            this.sp2_or_rc = resData.data?.import_export == 'import' 
            ? 'SP2' :
              resData.data?.import_export == 'export' 
                ? 'RC' : '';
          })
          .catch( e => console.log("catch then ",e))
          .finally(()=>{
            this.old_new = oldFlag
            if(oldFlag){
              console.log('lawas')
              this.$bvModal.show('qrModal2_old');
            }else{
              console.log('nyar')
              this.$bvModal.show('qrModal2');
            }
          })
        });
      }else{
        this.$bvModal.show('qrModal2');
      }

      console.log(this.selectedPermitModal2);

      // expired date
      let regDate = this.selectedPermitModal2.permit_date.match(/[-|0-9]+/)
      let regDateConv = new Date(regDate);
      regDateConv.setDate(
        (new Date(regDate)).getDate() + 5
      );
      let exp = regDateConv.toLocaleDateString('id-ID')
        .split('/').reverse().join('-');
        
      this.selectedPermitModal2.expired = exp;

      console.log('tmpQRCodeIndex inspect',this.tmpQRCodeIndex);
      console.log('old_new', this.old_new);
    },
    async copyToClipboard(qrcode) {
      if (!qrcode) {
        this.$bvToast.toast(`QRCode does not exists`, {
          title: 'Error!',
          autoHideDelay: 1500,
          variant: 'danger',
        })
        return;
      }
      const url = new URL(window.location.href);
      const text = `${url.origin}/static/qrcode/${qrcode}`;
      await this.$copyText(text)
      this.$bvToast.toast(`Code [${text}] copied`, {
        title: 'Success!',
        autoHideDelay: 1500,
        variant: 'success',
      })
    },
    async correction(qrcode){
      const wrongGateCorrection = await getDetailQR(qrcode);
      const gate_permit = JSON.parse(wrongGateCorrection);
      const body = {};
      if(gate_permit.message == 'success'){
        body.qr = qrcode;
        body.vehicle = gate_permit.data.vehicle;
        body.container = gate_permit.data.container;
        body.vehicle = gate_permit.data.vehicle;
        {{ this.selectedPermit.permit_date.replace(/\+.*/, '') }}
        body.direction = gate_permit.data.direction;
        body.driver_name = gate_permit.data.driver_name;
        
        const body_resp = await gateCorrection(body);
        const correction_resp = JSON.parse(body_resp);

        // const correction_resp = {}; //test
        // correction_resp.message = 'success';

        if (correction_resp.message == 'success') {
          this.$bvToast.toast(`Kesalahan masuk gate berhasil dikoreksi.`, {
            title: 'Success!',
            autoHideDelay: 1500,
            variant: 'success',
          })
          return;
        }
      }
    },
    async cancelPermit(permit) {
      this.isCancelling = true;
      try {
        this.$v.cancellationForm.$touch();
        if (this.$v.cancellationForm.$anyError) {
          this.$bvToast.toast(`Missing required information!`, {
            title: 'Error!',
            autoHideDelay: 1500,
            variant: 'danger',
          })
          return;
        }

        const data = {
          permit_id: permit.id,
          status: 0,
          username: this.loggedInUser.username,
          desc: this.cancellationForm.desc,
        }
        await setPermitStatus(data);
        this.isCancelling = false
        this.$nextTick(() => {
          this.$v.$reset();
        });
        this.$bvModal.hide('cancelConfirmation');
        this.$refs.table.refresh();
      } catch (e) {
        this.isCancelling = false
        if (!hasOwnProperty(e, 'response')) {
          this.$bvToast.toast(`${e.message}`, {
            title: 'Error!',
            autoHideDelay: 1500,
            variant: 'danger',
          })
          return;
        }
      }
    },
    async addContainerToList(){
      this.$v.container.$touch();
      if (this.$v.container.$anyError) {
        this.$bvToast.toast(`Missing required information!`, {
          title: 'Error!',
          autoHideDelay: 1500,
          variant: 'danger',
        })
        return;
      }
      this.addingToContainer = true;
      this.container = Str.removeAllWhitespaces(this.container)
      const exists = this.permit.container.filter(({container}) => container === this.container)
      if (exists.length > 0) {
        this.$bvToast.toast(`Container ${this.container} already in the list!`, {
          title: 'Duplication Error!',
          autoHideDelay: 1500,
          variant: 'danger',
        })
        this.addingToContainer = false;
        return;
      }

      /* here addplus container | di validasi oleh btos */
      console.log('this.container',this.container);
      this.permit.direction = 1;
      if(!this.cargoType){
        const btosValidate = await rspValidateBtos({
            container: this.container,
            direction: this.permit.direction,
            status: this.containerType == true ? 1 : 2,
          });
          
        const ctrValidated = JSON.parse(btosValidate);

        console.log('ctrValidated.data',ctrValidated);
       
        if (ctrValidated.data.length == 0) {
          console.log("btos validasi");
          this.isNullContainer = true
          if (this.valueDir == '') {
            this.addingToContainer = false;
            return;
          }
        }

        // balikan btos
        console.log(btosValidate);

        if(ctrValidated.status == 404){
          this.$bvToast.toast(`Kontainer ${this.container} belum ${this.containerType?'SP2':'RC'}!`, {
            title: 'Not Found',
            autoHideDelay: 1500,
            variant: 'danger',
          })
          this.addingToContainer = false;
          return;
        }

        console.log('ctrValidated',ctrValidated);
        console.log('addplus->permit.direction',this.permit.direction);

        // this.btos_sp2rc.direction = this.isNullContainer ?  this.valueDir :this.permit.direction; //prod new

        this.btos_sp2rc.direction = this.permit.direction; //prod old
        this.btos_sp2rc.id = ctrValidated?.data?.id ?? "";
        this.btos_sp2rc.exim = ctrValidated?.data?.import_export?? "";
        this.btos_sp2rc.container = ctrValidated?.data?.container_no?? this.container;
        this.btos_sp2rc.vessel = ctrValidated?.data?.vessel?? "";
        this.btos_sp2rc.voyage = ctrValidated?.data?.voyage?? "";
        this.btos_sp2rc.block = ctrValidated?.data?.block?? "";
        this.btos_sp2rc.slot = ctrValidated?.data?.slot?? "";
        this.btos_sp2rc.row = ctrValidated?.data?.row?? "";
        this.btos_sp2rc.tier = ctrValidated?.data?.tier?? "";

        // this.btos_sp2rc.direction = this.permit.direction; //test
        // this.btos_sp2rc.id = 12345;
        // this.btos_sp2rc.exim = 'import';
        // this.btos_sp2rc.container = this.container;
        // this.btos_sp2rc.vessel = 'SITC HAKATA';
        // this.btos_sp2rc.voyage = '24125';
        // this.btos_sp2rc.block = ctrValidated?.data?.block?? "A1";
        // this.btos_sp2rc.slot = ctrValidated?.data?.slot?? "11";
        // this.btos_sp2rc.row =  ctrValidated?.data?.row?? "22";
        // this.btos_sp2rc.tier = ctrValidated?.data?.vessel?? "01";
      }
      console.log('this.btos_sp2rc #here',this.btos_sp2rc);
      /* end addplus container */

      try {
        // comment2 test
        if (this.isNullContainer) {
          // 
          console.log("oldhere->value dir", this.valueDir);
          
          this.permit.direction = this.valueDir;
          const {data: {data: {rows}}} = await findContainerLocal({
            container: this.container,
            direction: this.permit.direction,
            status: 0,
          });
          this.permit.container.push({ no: rows.container.no, voyage: rows.container.voyage });
          
        } else if(this.containerType == true){
          console.log('out')
          const {data: {data: {rows}}} = await findContainerLocal({
            container: this.container,
            direction: 2,
            status: 0,
          });

          this.permit.container.push({ 
            no: this.btos_sp2rc.container, 
            voyage: rows.container.voyage, // this.btos_sp2rc.voyage
            vessel: this.btos_sp2rc.vessel,
            block: this.btos_sp2rc.block,
            slot: this.btos_sp2rc.slot,
            row: this.btos_sp2rc.row,
            tier: this.btos_sp2rc.tier,
          }); // prod
        }else{
          console.log('in')
          const {data: {data: {rows}}} = await findContainerLocal({
            container: this.container,
            direction: 1,
            status: 0,
          });
          // comment3 test
          // this.permit.container.push({ no: rows.container.no, voyage: rows.container.voyage }) // prod old
          console.log("test input");
         
          this.permit.container.push({ 
            no: this.btos_sp2rc.container, 
            voyage: rows.container.voyage, // this.btos_sp2rc.voyage
            vessel: this.btos_sp2rc.vessel,
            block: this.btos_sp2rc.block,
            slot: this.btos_sp2rc.slot,
            row: this.btos_sp2rc.row,
            tier: this.btos_sp2rc.tier,
          }); // prod
        }

        // TEST
        // this.permit.container.push({ 
        //     no: this.btos_sp2rc.container, 
        //     voyage: this.btos_sp2rc.voyage, // this.btos_sp2rc.voyage
        //     vessel: this.btos_sp2rc.vessel,
        //     block: this.btos_sp2rc.block,
        //     slot: this.btos_sp2rc.slot,
        //     row: this.btos_sp2rc.row,
        //     tier: this.btos_sp2rc.tier,
        //   });

        this.container = null;
        this.$nextTick(() => {
          this.$v.container.$reset();
        });
        this.addingToContainer = false;
      } catch (e) {
        this.addingToContainer = false;
        if (!hasOwnProperty(e, 'response')) {
          this.$bvToast.toast(`${e.message}`, {
            title: 'Error!',
            autoHideDelay: 1500,
            variant: 'danger',
          })
          return;
        }
      }
    },
  },
  mounted() {
  }
}
</script>

<style scoped>

</style>
